import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-flex-tcb',
    templateUrl: './flex-top-center-bottom.component.html',
    styleUrls: ['./flex-top-center-bottom.component.css']
})
export class FlexTopCenterBottomComponent implements OnInit {
    @Input() ecpTopHeight: number = 0;
    @Input() ecpBottomHeight: number = 0;

    @Input() ecpTopBg: string = '#ffffff';
    @Input() ecpBottomBg: string = '#ffffff';
    @Input() ecpBodyBg: string = '#ffffff';
    @Input() ecpStyle: object = {};

    constructor() {
    }

    ngOnInit() {
    }
}
